import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";

export const AREA_COLUMNS_DATA = ({
  deleteRow,
  editArea,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Id",
    accessor: "id",
    disableSortBy: true,
  },
  {
    Header: "Date",
    accessor: "date",
    disableSortBy: true,
  },
  {
    Header: "Commission",
    accessor: "commission",
    disableSortBy: true,
  },
  {
    Header: "",
    accessor: "ffddff",
    disableSortBy: true,
  },
  // {
  //   Header: "",
  //   accessor: "ids",
  //   disableSortBy: true,
  //   Cell: ({ cell }) => {
  //     return (
  //       <>
  //         <button
  //           disabled={!filters.is_active}
  //           className={classNames("btn dropdown-toggle", {
  //             "btn-primary": filters.is_active,
  //             "btn-secondary": !filters.is_active,
  //           })}
  //           type="button"
  //           data-bs-toggle="dropdown"
  //           aria-expanded="false"
  //         >
  //           More...
  //         </button>
  //         <ul className="dropdown-menu">
  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editArea(cell.row.original)}
  //             >
  //               Edit
  //             </button>
  //           </li>
  //           {isSuperFranchise != 1 &&
  //             isFranchiseEmployee != 1 &&
  //             isSubFranchise != 1 && (
  //               <li>
  //                 <button
  //                   className="dropdown-item"
  //                   onClick={() => deleteRow(cell.row.original)}
  //                 >
  //                   Delete
  //                 </button>
  //               </li>
  //             )}
  //           <li>
  //             <button className="dropdown-item">Something else here</button>
  //           </li>
  //         </ul>
  //       </>
  //     );
  //   },
  // },
];

export const AREA_FORM_CONFIG = (rowData) => [
  {
    label: "Area Name",
    type: "input-text",
    name: "area_name",
    defaultValue: rowData?.area_name || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Collection Charge",
    type: "input-number",
    name: "collection_charge",
    defaultValue: rowData?.collection_charge || "",
    validations: {
      required: true,
    },
  },
  {
    label: "Delivery Charge",
    type: "input-number",
    name: "delivery_charge",
    defaultValue: rowData?.delivery_charge || "",
    validations: {
      required: true,
    },
  },
  {
    label: "State",
    type: "select",
    name: "state",
    defaultValue: rowData?.state_id || "",
    options: [], // Populate this with state options
    validations: {
      required: true,
    },
  },
  {
    label: "Zone",
    type: "select",
    name: "zone_id",
    options: [], // Populate this with state options
    defaultValue: rowData?.zone_id || "",
    validations: {
      required: true,
    },
  },
];

export const AREA_OPTIONS = [
  { key: "area_name", value: "Area Name" },
  { key: "collection_charge", value: "Collection Charge" },
  { key: "delivery_charge", value: "Delivery Charge" },
  { key: "state", value: "State" },
  { key: "country_code", value: "Country Code" },
  { key: "zone", value: "Zone" },
];

export const AREA_STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "Inactive" },
];

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const AREA_FILTER_DEFINITIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: AREA_OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: AREA_STATUS_OPTIONS[0].key,
  },
  {
    name: "year",
    type: FILTER_TYPE.NUMBER,
    initialValue: currentYear,
  },
  {
    name: "month",
    type: FILTER_TYPE.TEXT,
    initialValue: monthNames[currentMonth - 1],
  },
];
